import React, { Suspense } from 'react';
import tw from "twin.macro";
import styled from "styled-components";
import { Content2Xl } from "components/misc/Layouts.js";
import { SectionHeadingH2 } from "components/misc/Headings.js";
import translationsHome from 'translations/home/en.js'

const SmallTestimonials = React.lazy(() => import('components/custom/SmallTestimonials.js'));

const TestimonialsContainer = styled.div`
${tw`-mx-8 px-8 bg-primary-900 text-gray-100`}
  background-color: #1a1a1a;
  background-image:
    radial-gradient(circle at 60% 70%, rgba(15, 35, 55, 0.95) 0%, rgba(25, 45, 65, 0.90) 50%, rgba(10, 30, 50, 0) 100%, transparent 100%),
    radial-gradient(circle at 50% 50%, rgba(20, 40, 60, 0.95) 0%, transparent 100%);
`;

const Heading = tw(SectionHeadingH2)`text-center leading-tight text-3xl mb-8 pt-12`;

const TestimonialsSection = ({ translations }) => {
  return (
    <TestimonialsContainer>
      <Content2Xl>
        <Heading>Gunbot user reviews</Heading>
        <Suspense fallback={<div>Loading testimonials...</div>}>
          <SmallTestimonials translations={translationsHome} />
        </Suspense>
      </Content2Xl>
    </TestimonialsContainer>
  );
};

export default TestimonialsSection;